import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "content"]

  connect() {
    console.log("Evaluations tabs controller connected")
    // Activer l'onglet dashboard par défaut si aucun onglet n'est spécifié dans l'URL
    const currentTab = this.data.get("currentTab") || "dashboard"
    this.activateTab(currentTab)
  }

  activateTab(event) {
    let tabName
    if (typeof event === 'string') {
      tabName = event // Called directly with a string (e.g., from connect)
    } else {
      event.preventDefault()
      tabName = event.currentTarget.dataset.tab
    }

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("btn-blue", tab.dataset.tab === tabName)
      tab.classList.toggle("btn-white", tab.dataset.tab !== tabName)
    })

    this.contentTargets.forEach(content => {
      content.classList.toggle("hidden", content.id !== `${tabName}-content`)
    })
  }
} 